import React from 'react'
import { ErrorImg } from '../../Module_Exporter/Module_Exporter'
import { Link } from 'react-router-dom'
import "./ErrorPage.css";
import Snowfall from 'react-snowfall';

import { Helmet } from 'react-helmet-async';

const ErrorPage = () => {
  return (
    <>
    <Helmet>    
    <title>CodeSperix-404</title>
    </Helmet>
    <section id="errorPageContainer">

    <img src={ErrorImg} alt="error page" />
    <Link to="/home" className='btn-1'>Back To Home</Link>
    </section>
    <div id="snow_fall_container">
    <Snowfall  snowflakeCount={100} color="#ffffff9d"
   />
  </div>
    </>
  )
}

export default ErrorPage